/** Meta (Facebook) Pixel ID — Events Manager data source. */
export const META_PIXEL_ID = "9361696187252386";
